import React from "react";
import { useParams } from "react-router-dom";
import { getAssistsLeagueTable } from '../../../api/getAssistsLeagueTable';

import styles from "./LeagueAssistsKingTable.module.css";

function LeagueAssistsKingTable() {
  const { leagueId } = useParams();
  const [scores, setScores] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    getAssistsLeagueTable(leagueId).then((data) => {
      setScores(data);
      setIsLoading(false);
    });
  }, [leagueId]);

  return (
    <div className={styles.leagueAssistsKingTable}>
      <div className="collapsBtn">מלכי הבישולים</div>
      <div className={`${styles.tableRow} ${styles.tableTopic}`}>
        <div>-</div>
        <div>שחקן</div>
        <div>קבוצה</div>
        <div>בישולים</div>
      </div>

      {isLoading ? (
        <div>הנתונים בטעינה ... </div>
      ) : (
        scores.map((score, index) => (
          <div
            key={score.user_id}
            className={`${styles.tableRow} ${
              index % 2 === 0 ? styles.odd : styles.even
            }`}
          >
            <div>{index}</div>
            <div>{score.full_name}</div>
            <div>{score.team_name}</div>
            <div>{score.assists_count}</div>
          </div>
        ))
      )}
    </div>
  );
}

export default LeagueAssistsKingTable;
